"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableSentry = exports.sentryIntegrations = void 0;
const Sentry = __importStar(require("@sentry/react"));
exports.sentryIntegrations = [];
if (SENTRY_ENABLED) {
    // @ts-expect-error Typing issue within sentry.
    exports.sentryIntegrations.push(Sentry.replayIntegration(), Sentry.httpClientIntegration());
}
const enableSentry = (additionalOptions = {}) => {
    if (SENTRY_ENABLED) {
        Sentry.init({
            dsn: SENTRY_FRONTEND_DSN,
            release: SENTRY_RELEASE,
            environment: APP_ENV,
            integrations: [Sentry.browserTracingIntegration(), ...exports.sentryIntegrations],
            tracesSampleRate: 'prod' === APP_ENV ? 0.2 : 1,
            tracePropagationTargets: SENTRY_FRONTEND_PROPAGATION_TARGETS,
            replaysSessionSampleRate: 0.2,
            replaysOnErrorSampleRate: 1,
            ...additionalOptions,
        });
    }
};
exports.enableSentry = enableSentry;
